export default __webpack_public_path__ + "static/media/mitsuhiro.f54148c6.png";